import React, { useState } from 'react';
import {
  Dropdown, DropdownItem, DropdownMenu, DropdownToggle,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import Gravatar from 'react-gravatar';
import SwaggerService from '../../utils/Swagger/SwaggerService';
import { defaultErrorFeedback, errorFeedback } from '../../actions/feedback';
import { connect, useDispatch } from 'react-redux'

interface IProps {
  companyName: string;
  logout: () => any;
  username: string;
  userEmail: string;
  handleToggle?: (event: React.KeyboardEvent<HTMLInputElement>) => any;
  dropdownOpen: boolean;
  existingToken?: string;
  hsoIdentityUrl?: string;
}

const UserDropdown: React.FC<IProps> = (props) => {
  const dispatch = useDispatch()

  const {
    userEmail, logout, companyName, username, dropdownOpen, handleToggle,
    existingToken, hsoIdentityUrl = process.env.REACT_APP_HSO_ID_URL
  } = props;
  
  const [isLoading, setIsLoading] = useState(false);
  
  const handleChange = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (handleToggle) {
      handleToggle(event);
    }
  };
  
  const handleLogout = () => {
    logout();
  };

  const handleSwaggerDocs = async () => {
    try {
      const response = await SwaggerService.access()

      if (response?.status === 200 && response?.data?.url) {
        const tab = window.open('', '_blank')
        if (!tab) {
            dispatch(defaultErrorFeedback())
            return
        }
        tab.location.href = response.data.url
      } else {
        dispatch(defaultErrorFeedback())
      }
    } catch (error) {
        dispatch(errorFeedback(error))
    }
  }

  return (
    <Dropdown direction="down" isOpen={dropdownOpen} toggle={handleChange} className="d-lg-block mr-sm-5 text-dark">
      <DropdownToggle nav>
        <Gravatar email={userEmail} size={45} className="img-avatar" />
        <div className="d-none d-sm-block float-right">
          <div className="d-table  ml-3 caret">
            <div className="d-table-row font-lg text-dark text-left"><strong>{username}</strong></div>
            <div className="d-table-row"><small className="d-block mt-n1 text-light">{companyName}</small></div>
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu right className="logindropdown">
        <Link to="/reset-password">
          <DropdownItem
            className="d-flex justify-content-between text-light"
          >
            <span><i className="icon icon-key text-light ml-2 " /></span>
            <span className="d-xs-none d-none d-sm-block">Reset Password</span>
          </DropdownItem>
        </Link>
        <a href={process.env.REACT_APP_HSO_ID_URL}>
          <DropdownItem
              className="d-flex justify-content-between text-light"
          >
            <span><i className="icon icon-user text-light ml-2 " /></span>
            <span className="d-xs-none d-none d-sm-block">Manage MFA</span>
          </DropdownItem>
        </a>
        <DropdownItem onClick={handleSwaggerDocs} className="d-flex justify-content-between text-light">
          <span><i className="icon icon-docs text-light ml-2 " /></span>
          <span className="d-xs-none d-none d-sm-block">API Documentation</span>
        </DropdownItem>
        {/*<Link to="/tutorials">
          <DropdownItem
            className="d-flex justify-content-between text-light"
          >
            <span><i className="icon icon-question text-light ml-2 " /></span>
            <span className="d-xs-none d-none d-sm-block">Tutorials</span>
          </DropdownItem>
        </Link>*/}
        <DropdownItem onClick={handleLogout} className="d-flex justify-content-between text-light">
          <span>
            {' '}
            <i className="icon icon-logout text-light ml-2" />
          </span>
          <span>Log out</span>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default UserDropdown;
